/**
 * Sesión de UI (perfil) sin secretos.
 * Los JWT viven solo en cookies HttpOnly del API; nunca en localStorage/sessionStorage.
 */

const USER_KEY = "user";

const LEGACY_TOKEN_KEYS = [
  "access_token",
  "refresh_token",
  "accessToken",
  "AUTH_TOKEN",
  "AUTH",
  "token",
] as const;

const AUTH_CHANNEL = "tz-auth";

export function clearLegacyAuthTokens(): void {
  try {
    for (const key of LEGACY_TOKEN_KEYS) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
  } catch {
    /* storage no disponible */
  }
}

export function setSessionUser(user: unknown): void {
  try {
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}

export function getSessionUser<T = any>(): T | null {
  try {
    const raw =
      sessionStorage.getItem(USER_KEY) || localStorage.getItem(USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function clearSessionUser(): void {
  try {
    sessionStorage.removeItem(USER_KEY);
    localStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}

/** Limpia perfil + leftovers de tokens en Web Storage. */
export function clearClientAuthState(): void {
  clearLegacyAuthTokens();
  clearSessionUser();
}

export function broadcastAuthEvent(type: "logout" | "login"): void {
  try {
    const ch = new BroadcastChannel(AUTH_CHANNEL);
    ch.postMessage({ type });
    ch.close();
  } catch {
    /* BroadcastChannel no soportado */
  }
}

export function subscribeAuthEvents(
  handler: (type: "logout" | "login") => void
): () => void {
  try {
    const ch = new BroadcastChannel(AUTH_CHANNEL);
    ch.onmessage = (ev) => {
      const t = ev?.data?.type;
      if (t === "logout" || t === "login") handler(t);
    };
    return () => ch.close();
  } catch {
    return () => undefined;
  }
}
